import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { LocalForm, Control, Errors } from 'react-redux-form';
import { localizations } from '../localization/localization';
import StarRating from './components/StarRating';
import { GiveFeedbackModel } from './models/GiveFeedbackModels';
import { renderErrorInfoText } from '../common/forms/FieldCreators';

interface FormProps {
    open: boolean;
    onSubmit: (data: any) => void;
    onCancel: () => void;
}


const initialModel = (): GiveFeedbackModel => {
    return {
        feedbackText: undefined,
        rating: 0,
    }
}

const GiveFeedbackDialog: React.SFC<FormProps> = (props) => {
    return <Dialog open={props.open}>
        <LocalForm
            onSubmit={(values) => props.onSubmit(values)}
            initialState={initialModel()}
        >
            <DialogTitle disableTypography>
                <Typography variant="h4" color="primary">{localizations.feedback.giveFeedback}</Typography>
            </DialogTitle>

            <DialogContent>
                <Typography paragraph color="primary" variant="subtitle1">{localizations.feedbackForm.moreQuestions}</Typography>
                <Typography variant="body2" paragraph>{localizations.feedbackForm.feedback}</Typography>

                <Typography variant="subtitle1" color="primary">{localizations.feedbackForm.rating}</Typography>

                <Control
                    type="number"
                    model=".rating"
                    component={(p) => <StarRating maxRating={5} {...p} />}
                    validators={{
                        ratingGiven: (val) => val && val > 0
                    }}
                    validateOn={["change", "blur"]}
                />
                 <Errors model=".rating"
                    show={{touched: true, focus: false}}
                    messages={{
                        ratingGiven: 'Anna arvosana'
                    }}
                    wrapper={renderErrorInfoText}
                />
                <br />
                <Typography variant="subtitle1" color="primary">{localizations.feedbackForm.leaveFeedback}</Typography>
                <Control.text model=".feedbackText" component={(p) => <TextField placeholder={localizations.feedbackForm.leaveFeedbackHere} multiline fullWidth rows={5} rowsMax={10} {...p} />} />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={props.onCancel}>{localizations.actions.cancel}</Button>
                <Button variant="contained" color="secondary" type="submit">{localizations.actions.send}</Button>
            </DialogActions>
        </LocalForm>
    </Dialog>
}

export default GiveFeedbackDialog;


// WEBPACK FOOTER //
// ./src/feedback/GiveFeedbackDialog.tsx